import {
  beSendGetSenderStatus,
  TRUSTED_SENDER_STATUS_NOT_CONFIRMED
} from 'Api/beSendGoApi'

async function fetchStatus(email) {
  const result = await beSendGetSenderStatus(email)

  let res = {
    Status: TRUSTED_SENDER_STATUS_NOT_CONFIRMED,
    ApplyOverrideDomain: false
  }

  if (result !== null) {
    res = {
      Status: result.Status,
      ApplyOverrideDomain: result.ApplyOverrideDomain
    }
  }

  return res
}

export default fetchStatus
